import type { TranslationInterface } from './translation.types';

export const esLocale: TranslationInterface = {
  ok: 'OK',
  yes: 'Sí',
  no: 'No',
  agree: 'De acuerdo',
  cancel: 'Cancelar',
  'yes-exit': 'Sí, salir',
  'yes-reset': 'Sí, restablecer',
  'no-cancel': 'No, cancelar',
  'are-you-sure': '¿Estás seguro?',
  recording: 'Grabando...',
  'thank-you': 'Gracias',
  'sorry-try-again': 'Lo sentimos, intenta de nuevo',
  'error-occurred': 'Ocurrió un error',
  'please-try-again': 'Por favor, inténtalo de nuevo',
  'write-a-message': 'Escribe un mensaje...',
  'send-message': 'Enviar mensaje',
  connected: 'Conectado',
  connecting: 'Conectando',
  reconnecting: 'Reconectando',
  reconnected: 'Reconectado',
  disconnecting: 'Desconectando',
  disconnected: 'Desconectado',
  error: 'Error',
  'persist-session': 'Persistir sesión',
  settings: 'Configuración',
  close: 'Cerrar',
  help: 'Ayuda',
  chat: 'Chat',
  send: 'Enviar',
  copy: 'Copiar',
  copied: 'Copiado',
  'sound-effects': 'Efectos de sonido',
  language: 'Idioma',
  select: 'Seleccionar',
  agent: 'Agente',
  user: 'Usuario',
  bot: 'Bot',
  'close-widget': 'Cerrar widget',
  'got-any-questions': '¿Tienes alguna pregunta? ¡Chatea con nosotros!',
  'typical-response-time': 'Normalmente respondemos en menos de 1 minuto',
  'session-closed-lead': '¡Tu problema fue resuelto!',
  'create-new-ticket': 'Crear nuevo ticket',
  exit: 'Salir',
  'reset-conversation': 'Restablecer conversación',
  'new-conversation': 'Nueva conversación',
  'welcome-title': 'Bienvenido a nuestro chat de soporte',
  'welcome-description':
    '¡Estamos aquí para ayudarte! Inicia una conversación y responderemos lo antes posible.',
  'your-name': 'Tu nombre',
  'your-email': 'Tu correo electrónico',
  'start-chat': 'Hablar con soporte',
  'starting-chat': 'Conectando...',
  'hello-greeting': '¡Hola! ¿Cómo podemos ayudarte hoy?',
  'i-need-more-help': 'Necesito más ayuda',
  'this-was-helpful': 'Esto fue útil',
  optional: 'Opcional',
  'no-conversations-yet': 'Sin conversaciones aún',
  'back-to-conversations': 'Volver a conversaciones',
  'closed-conversations': 'Conversaciones cerradas',
};
